export default __webpack_public_path__ + "static/media/ICDD_download_header.85f68e8c.png";